import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { BlueButton, BlockLabelNoMargin } from "./styleCustom";
import { FormRightHeader, BackTo } from "./formComponents";
import { CheckSquare, Square } from "./icons";
import { Row } from "react-bootstrap";
import { MyContext, ListContext } from "./MyContext";

import { RemoveIconNoPosition } from "./icons";
// import AuthHelperMethods from "./AuthHelperMethods";
import Auth from "./Auth";

const SectionAssignStudent = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  let params = {};
  const [assignedArray, SetAssignedArray] = useState([]);
  const [search, setSearch] = useState("");

  let history = useHistory();
  function goBackToList() {
    history.push("/admin/setup/sections");
  }
  let section_id = useParams().id;
  var section_name = "section";

  const handleSearchChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  useEffect(
    () => {
      const fetchData = async () => {
        let params = {};
        params.section_id = section_id;
        const result = await Auth.api(
          "section_students/sectionStudentsArray",
          "get",
          params,
        );
        SetAssignedArray(result.data.sectionStudentsArray);
      };
      if (section_id) fetchData();

      /* return () => {
        dispatch2(["CLEAR_SECTION_STUDENTS"]);
      };*/
    },
    //eslint-disable-next-line
    [section_id],
  );
  useEffect(
    () => {
      const fetchData = async () => {
        const result = await Auth.api("students/index", "get");
        dispatch2(["STUDENTS_GET", result.data]);
      };
      fetchData();
    },
    //eslint-disable-next-line
    [],
  );

  /*useEffect(
    () => {
      console.log("useEffect");
      window.searchinputRef = searchinputRef;
      searchinputRef.current.focus();
    },
    //eslint-disable-next-line
    []
  );
*/
  // const searchinputRef = React.createRef();

  const unassign = async (objectIn) => {
    let params = { student_id: objectIn.id, section_id: section_id };
    let result = await Auth.api("section_students/delete", "post", params);
    SetAssignedArray(result.data.sectionStudentsArray);
  };

  const addStudentToSection = async (objectIn) => {
    let params = { student_id: objectIn.id, section_id: section_id };

    try {
      let result = await Auth.api("section_students/create", "post", params);
      SetAssignedArray(result.data.sectionStudentsArray);
    } catch (error) {
      console.log(error);
    }
  };

  if (!listState.sectionList) return null;
  if (!listState.studentList) return null;

  section_name =
    listState.sectionList.find((item) => item.id == section_id).section_name ||
    "section";
  return (
    <>
      <BackTo url={`/admin/setup/sections`} pagename={"section list"} />

      <div
        style={{
          display: "flex",
          flex: "1 1 100%",
          minWidth: 700,
          justifyContent: "center",
          marginBottom: 100,
        }}
      >
        <div className="Border">
          <div
            className="header"
            style={{
              display: "flex",
              flexWrap: "wrap",
              flex: "1 1 100%",
              justifyContent: "center",
            }}
          >
            <FormRightHeader>{`Assign Students to ${section_name} `}</FormRightHeader>
          </div>

          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            <div
              className="left"
              style={{
                display: "flex",
                flexWrap: "wrap",
                flex: "1 1 50%",
                alignContent: "flex-start",
                padding: 10,
                marginRight: 60,
              }}
            >
              {" "}
              <BlockLabelNoMargin>
                {" "}
                assigned section students{" "}
              </BlockLabelNoMargin>
              {assignedArray < 1 && <p>No Students Assigned</p>}
              {assignedArray.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flex: "1 1 100%",
                    flexDirection: "column",
                  }}
                >
                  {listState.studentList
                    .filter((student) => assignedArray.includes(student.id))
                    .map((item) => (
                      <div
                        key={item.id}
                        onClick={() => unassign(item)}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: 5,
                        }}
                      >
                        {item.name || item.student_name}{" "}
                        <RemoveIconNoPosition />
                      </div>
                    ))}
                </div>
              )}
            </div>

            <div
              className="right"
              style={{
                display: "flex",
                flex: "1 1 50%",
                flexDirection: "column",
              }}
            >
              <input
                style={{ marginTop: 10, marginBottom: 10 }}
                autoFocus
                type="text"
                value={search}
                onChange={(e) => handleSearchChange(e)}
                placeholder="start typing to search for a client"
              />
              {listState.studentList && listState.studentList.length > 0 && (
                <div>
                  {listState.studentList
                    .filter((student) =>
                      student.name.toLowerCase().includes(search.toLowerCase()),
                    )
                    .map((item) => (
                      <div
                        key={item.id}
                        onClick={() =>
                          assignedArray && assignedArray.includes(item.id)
                            ? unassign(item)
                            : addStudentToSection(item)
                        }
                        style={{ display: "flex", marginBottom: 5 }}
                      >
                        {assignedArray && assignedArray.includes(item.id) ? (
                          <CheckSquare />
                        ) : (
                          <Square />
                        )}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: 20,
                            cursor: "pointer",
                          }}
                        >
                          {" "}
                          {item.name}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
          <Row
            style={{
              justifyContent: "center",
              display: "flex",
              flex: "1 1 100%",
            }}
          >
            <BlueButton onClick={() => goBackToList()}>{"Close"} </BlueButton>
          </Row>
        </div>
      </div>
    </>
  );
};

export default SectionAssignStudent;
